// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.clickable[data-v-5c94edf6] \n{\n\tcursor: pointer;\n}\n.appointment-info[data-v-5c94edf6]\n{\n\tbackground-color: grey !important;\n\theight: 10px\n}\n.selected-background[data-v-5c94edf6]\n{\n\tbackground-color: #e5ffe5\n}\n", ""]);
// Exports
module.exports = exports;
